// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12RHO","colMin":"styles_colMin__2qPNQ"};